/**
 * 
 * @copyright     (c) 2024-2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/_components/VideoRecorder/_components/OverlayMiddlePlayback.js
 * Created:       Mon May 06 2024
 * Modified By:   Greg Olive
 * Last Modified: Tue Nov 04 2025
 */

import React, { useContext } from "react";
import { getImage } from "../../../../_utils";
import VideoProgressBar from "./VideoProgressBar";

import {TranslationsContext} from "@proxy/_contexts";

export default function OverlayMiddlePlayback({
  overlayState,
  setOverlayState,
  startCamera,
  playRecording,
  media,
  videoDuration
}) {
  const translations = useContext(TranslationsContext);

  const playbackButtonMarkup = ( overlayState === "playback-complete" ) ?
    <div className={"gc__svg_large_buttons_container"}>
      <div className={"gc__playback_button_group"}>
        <div className={"gc__playback_button_title"}>Re-record</div>
        <div className={"gc__svg_button_large_container_redo"}>
          <button
            type={"button"}
            className={"gc__svg_button_large"}
            onClick={() => startCamera()}
          >
            <img
              className={"gc__svg_redo"}
              src={getImage("./icons/fontAwesome/redo-alt-solid.svg")}
              alt="Redo button icon"
            />
          </button>
        </div>
      </div>

      <div className={"gc__playback_button_group"}>
        <div className={"gc__playback_button_title"}>Playback</div>
        <div className={"gc__svg_button_large_container_playback"}>
          <button
            type={"button"}
            className={"gc__svg_button_large"}
            onClick={() => {
              playRecording();
              setOverlayState("playback-inProgress");
            }}
          >
            <img
              className={"gc__svg_filtered"}
              src={getImage("./icons/fontAwesome/play-solid.svg")}
              alt="Play button icon"
            />
          </button>
        </div>
      </div>

      <div className={"gc__playback_button_group"}>
        <div className={"gc__playback_button_title"}>Accept</div>
        <div className={"gc__svg_button_large_container_accept"}>
          <button
            type={"button"}
            className={"gc__svg_button_large"}
            onClick={() => setOverlayState("thumbnail")}
          >
            <img
              className={"gc__svg_accept"}
              src={getImage("./icons/fontAwesome/check-solid.svg")}
              alt="Accept button icon"
            />
          </button>
        </div>
      </div>
    </div> :
    <VideoProgressBar media={media} videoDuration={videoDuration} />;

  return (
    <div className={"gc__overlay_middle_playback_container"}>
      { playbackButtonMarkup }

    </div>
  );
}

// <div className={"gc__svg_button_text"}>{ translations.video_recorder_button_use }</div>
// <div className={"gc__svg_button_text"}>{ translations.video_recorder_button_redo }</div>
